export const chats = {
  chatListChatIfoAttachmentsText: 'Bilaga(r) skickad(e)',
  chatListChatNoMessagesText: 'Inga meddelanden ännu',
  chatArchivedTitle: 'Arkiverade chattar',
  chatsCreatePrivateCurtainTitle: 'Ny chatt',
  chatsCreatePrivateCurtaiSearchInputPlaceholder: 'Sök',
  chatsCreatePrivateCurtainCreateButtonTitle: 'Skapa',
  chatCreateButtonTitle: 'Nästa',
  chatCreateNewGroupHeader: 'Ny grupp',
  chatGroupNameInputTitle: 'Gruppnamn',
  chatLogoTitle: 'Redigera',
  chatCreateGroupButtonTitle: 'Skapa grupp',
  chatRequiredFieldsAlert: 'Gruppnamn måste anges!',
  chatsCreateGroupChatLongTitleAlertText: 'Använd en kortare titel!',
  chatsCreateGroupChatLBigImageAlertText: 'Vänligen välj en mindre bild!',
  chatsNewChatInputPlaceholder: 'Skriv ett meddelande',
  chatsNewChatAddedBigImageAlertText: 'Vänligen välj en mindre bild!',
  chatOwnersArchiveOptionText: 'Arkiv',
  chatOwnersEditGroupOptionText: 'Redigera',
  chatOwnersManageGroupOptionText: 'Hantera medlemmar',
  chatOwnersChangeGroupOptionText: 'Ändra gruppägare',
  chatOwnersLeaveGroupOptionText: 'Lämna',
  chatOwnersDeleteGroupOptionText: 'Radera chatt',
  chatpopupArchivedTitle: 'Arkivera chatt',
  chatpopupArchivedDescription: 'Är du säker?',
  chatArchiveGroupButtonTitleYes: 'Bekräfta',
  chatArchiveGroupButtonTitleCancel: 'Avbryt',
  chatEditGroupHeader: 'Redigera chatt',
  chatEditGroupEditLogoTitle: 'Redigera',
  chatEditGroupButtonTitle: 'Spara',
  chatGroupEditAlertText: 'Sparat framgångsrikt!',
  chatManageGroupHeader: 'Hantera',
  chatManageGroupButtonTitle: 'Lägg till medlem',
  chatManageGroupSaveButtonTitle: 'Spara',
  chatAddUsersGroupHeader: 'Lägg till medlemmar',
  chatAddUsersGroupButtonTitle: 'Bekräfta',
  chatAddUsersGroupSearchInputPlaceholder: 'Sök',
  chatOwnershipTransferHeader: 'Överför ägarskap',
  chatOwnershipTransferSearchInputPlaceholder: 'Sök',
  chatOwnershipTransferButtonTitle: 'Bekräfta',
  chatOwnerMarkText: '(du)',
  chatOwnershipTransferAlertText: 'Ägarskap överfört!',
  chatOwnerLeaveGroupTitle: 'Lämna gruppen',
  chatOwnerLeaveGroupDescription: 'Du är ägare till chatten, så du måste välja en ny ägare innan du lämnar gruppen.',
  chatOwnerLeaveGroupButtonTitleYes: 'Välj',
  chatOwnerLeaveGroupButtonTitleNo: 'Avbryt',
  chatsGroupChatUsersCurtanArchOptionTitle: 'Arkiv',
  chatsGroupChatUsersCurtanMembersOptionTitle: 'Chattmedlemmar',
  chatsGroupChatUsersCurtanLeaveOptionTitle: 'Lämna',
  chatsGroupChatMemberCurtainTitle: 'Chattmedlemmar',
  chatsGroupChatMemberCurtainSearchInputPlaceholder: 'Sök',
  chatsGroupChatMemberCurtainOwnerMarkText: '(ägare)',
  chatsGroupChatLeavePopupTitle: 'Lämna',
  chatsGroupChatLeavePopupText: 'Är du säker?',
  chatsGroupChatLeavePopupCancelButtonTitle: 'Avbryt',
  chatsGroupChatLeavePopupConfirmButtonTitle: 'Bekräfta',
  chatDeleteGroupTitle: 'Radera chatt',
  chatDeleteGroupDescription: 'Chatten och dess historik kommer att raderas för alla deltagare, fortsätta?',
  chatDeleteGroupButtonTitleYes: 'Bekräfta',
  chatDeleteGroupButtonTitleNo: 'Avbryt',
  chatsPrivateChatCurtainArchOptionTitle: 'Arkiv',
  chatsEditMessage: 'Redigera meddelande',
  chatsCopyMessage: 'Kopiera meddelande',
  chatsDeleteMessage: 'Radera meddelande',
  chatsSelectMessage: 'Välj meddelande',
  chatMarkTextEdit: '(redigerad)',
  chatCopyMessageAlertText: 'Meddelande kopierat!',
  chatDeleteMessageTitle: 'Radera meddelande',
  chatDeleteMessageDescription: 'Radera detta meddelande?',
  chatDeleteMessageButtonTitleYes: 'Bekräfta',
  chatDeleteMessageButtonTitleNo: 'Avbryt',
  chatSelectButtonDelete: 'Avbryt',
  chatSelectButtonNo: 'Radera',
  chatDeleteMessagesTitle: 'Radera meddelanden',
  chatDeleteMessagesDescription: 'Radera dessa meddelanden?',
  chatDeleteMessagesButtonTitleYes: 'Bekräfta',
  chatDeleteMessagesButtonTitleNo: 'Avbryt',
  chatArchiveButtonRestore: 'Återställ',
  chatArchiveButtonNo: 'Radera',
  chatNoUsersCurtainTitle: 'Hoppsan!',
  chatsNoUsersCurtainText: 'Det verkar som att det inte finns några andra användare förutom dig. Bjud in vänner för att börja chatta.',
  chatsNoUsersCurtainCancelButtonTitle: 'Avbryt',
  chatsNoUsersCurtainCopyButtonTitle: 'Kopiera app-länk',
  chatsAppLinkCopiedAlertText: 'Länk kopierad!',
  chatsTooFewUsers: 'Vänligen välj minst en användare för att börja chatta!',
  chatsError: 'Något gick fel!'
}
